import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm$items;
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return ((_vm$items = _vm.items) === null || _vm$items === void 0 ? void 0 : _vm$items.length) > 0 ? _c(_setup.SGroup, {
    class: _vm.$style.offerSlider,
    attrs: {
      "swiper": _setup.swiperOptions
    }
  }, _vm._l(_vm.items, function (item, index) {
    return _c('div', {
      key: index,
      class: _vm.$style.slide
    }, [_c('div', {
      class: _vm.$style.offerItem
    }, [_c('div', {
      class: _vm.$style.offerItemTitle
    }, [_vm._v("\n        " + _vm._s(item.title) + "\n      ")]), _vm._v(" "), _c('div', {
      class: _vm.$style.offerItemBottom
    }, [_c('div', {
      class: _vm.$style.offerItemTextWrapper
    }, [_c('div', {
      class: _vm.$style.offerItemText,
      domProps: {
        "innerHTML": _vm._s(item.description)
      }
    }), _vm._v(" "), item.note ? _c('div', {
      class: _vm.$style.offerItemFootnote
    }, [_vm._v("\n            " + _vm._s(item.note) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      class: _vm.$style.offerItemIcon
    }, [item.image.aws ? _c(_setup.SImageLazy, {
      attrs: {
        "src": item.image.aws,
        "alt": item.title,
        "object-fit": "contain",
        "fade": ""
      }
    }) : _vm._e()], 1)])])]);
  }), 0) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };